import SliderCustom from './SliderCustom'
import SliderPopover from './SliderPopover'

export { SliderPopover }
export default SliderCustom
